import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './SquareApartmentInput.module.scss';
import {stepperInfoActions} from "../../store/slices/stepperInfoSlice";

const SquareApartmentInput = () => {
  const dispatch = useDispatch();
  const {squareApartment, service_package, typeBuilding} = useSelector(state => state.stepperInfo);

  const handleSetSquare = (e) => {
    // clear error if it exists
    const areaLabel = document.getElementById("area");

    if (areaLabel) {
      const inputElement = areaLabel.querySelector("input");
      if (inputElement) {
        inputElement.style.borderColor = "rgba(231, 232, 233, 1)";
      }

      let errorMessageSpan = areaLabel.querySelector("span");
      if (errorMessageSpan) {
        areaLabel?.removeChild(errorMessageSpan);
      }
    }

    const square = e.target.value;
    const regex = /^\d+$/;

    if (regex.test(square)) {
      dispatch(stepperInfoActions.setSquareApartment(square));
    } else {
      dispatch(stepperInfoActions.setSquareApartment(""));
    }
  }

  return (
    <form action="#" className={styles.squareInput}>
      <p className={styles.squareInput_title}>Площа {typeBuilding || service_package?.name} <sup>*</sup>
      </p>
      <label id={"area"} className={styles.squareInput_inputContainer}>
        <input
          className={styles.input}
          type="number"
          placeholder={'Введіть площу'}
          value={squareApartment}
          onChange={handleSetSquare}
        />
      </label>
    </form>
  );
};

export default SquareApartmentInput;
